module.exports = __webpack_public_path__ + "img/servicos.83ccd685.png";